module.exports = __webpack_public_path__ + "img/charm_7.0e629280.svg";